import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonConstant } from 'src/app/constants';

@Component({
  selector: 'pos-avatar-control',
  templateUrl: './avatar-control.component.html',
  styleUrls: ['./avatar-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarControlComponent {
  @Input() value = CommonConstant.DEFAULT_PHOTO;

  readonly DEFAULT_PHOTO = CommonConstant.DEFAULT_PHOTO;

  onImageLoadFailed() {
    if (this.value !== this.DEFAULT_PHOTO) {
      this.value = this.DEFAULT_PHOTO;
    }
  }
}
